const settings = {
  email: {
    key: 'email',
    label: 'Email'
  },
  phone: {
    key: 'phone',
    label: 'Phone'
  }
}

const keys = Object.values(settings).map(o => o.key)
const labels = Object.values(settings).map(o => o.label)
const sources = Object.values(settings).reduce((m, o) => Object.assign(m, { [o.label]: o.key }), {})

export default {
  settings,
  keys,
  labels,
  sources
}
